/* eslint-disable */
function giftupInit(g, i, f, t, u, p, s) {
  g[u] =
    g[u] ||
    function () {
      (g[u].q = g[u].q || []).push(arguments);
    };
  p = i.createElement(f);
  p.async = 1;
  p.src = t;
  s = i.getElementsByTagName(f)[0];
  s.parentNode.insertBefore(p, s);
}

export default () => {
  giftupInit(window, document, 'script', 'https://cdn.giftup.app/dist/gift-up.js', 'giftup');
};

// Subscribe to a Gift Up event ("load", "resize", "conversion", ...) even
// before the script has been requested; calls are queued until it loads.
export const giftupOn = (event, callback) => {
  window.giftup =
    window.giftup ||
    function () {
      (window.giftup.q = window.giftup.q || []).push(arguments);
    };
  window.giftup(event, callback);
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/lib/giftup.js